// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tab-item_tabs__gGegC","tabItem":"tab-item_tabItem__cm1P9","tabItemActive":"tab-item_tabItemActive__qWrSz"};